import assign from 'object-assign';

if (!Object.assign) {
  // polyfill is required because the react-app preset assumes
  // it is present and prefers the built-ins for this
  Object.assign = assign;
}
